module.exports = __webpack_public_path__ + "img/register-btn.a5542f7e.png";